import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import { SafetyCheckContentData } from '@/api/generated/safetyCheckContentController';
import { API_CONTEXT } from '../config';
import SafetyCheckNotice from '@/types/table/safetyCheckNotice';

const { buildGetUrl } = useUrlBuilder();

export interface SafetyCheckNoticeData extends SafetyCheckNotice {
  safetyCheckContentList?: SafetyCheckContentData[];
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class SafetyCheckNoticeController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<SafetyCheckNoticeData>>(
      API_CONTEXT + '/upms/safetyCheckNotice/list',
      params,
      httpOptions,
    );
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<SafetyCheckNoticeData>(
      API_CONTEXT + '/upms/safetyCheckNotice/view',
      params,
      httpOptions,
    );
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/upms/safetyCheckNotice/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/upms/safetyCheckNotice/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/upms/safetyCheckNotice/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/safetyCheckNotice/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/safetyCheckNotice/update', params, httpOptions);
  }
  static submitFeedback(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/safetyCheckNotice/submitFeedback', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/safetyCheckNotice/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/safetyCheckNotice/deleteBatch', params, httpOptions);
  }
  static myList(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<SafetyCheckNoticeData>>(
      API_CONTEXT + '/upms/safetyCheckNotice/myList',
      params,
      httpOptions,
    );
  }
}
